module.exports = __webpack_public_path__ + "img/password-lock-circle.084f4064.svg";